module.exports = __webpack_public_path__ + "img/lamden.8f34b556.png";